// @tennis-matches/core/utils
// Common utility functions for type conversion
// Migrated from apps/schleifchen/src/modules/utils/commonHelpers.js

/**
 * Safely converts a value to a trimmed string
 * @param {*} x - Value to convert
 * @returns {string} Trimmed string or empty string
 */
export function __asStr(x) {
  return String(x ?? "").trim();
}

/**
 * Safely converts a value to an integer with default fallback
 * @param {*} x - Value to convert
 * @param {number} d - Default value if conversion fails
 * @returns {number} Integer value or default
 */
export function __asInt(x, d = 0) {
  const n = Number(x);
  return Number.isFinite(n) ? Math.trunc(n) : d;
}
